const emergencyAf = {
  buttons: {
    gas: 'ګاز سیلنډر',
    medicine: 'عاجل درمل',
  },
  common: {
    nameLabel: 'ستاسو نوم',
    phoneLabel: 'د موبایل شمیره',
    villageLabel: 'کلي/سیمه',
    houseNumberLabel: 'د کور شمیره',
    detailsLabel: 'اضافي معلومات',
    detailsPlaceholder: 'هیڅ ځانګړي لارښوونې',
    districtLabel: 'ولایت',
    upazillaLabel: 'وړاندیز',
    cancel: 'لغوه کول',
  },
  gas: {
    title: 'ګاز سیلنډر ډکول',
    companyLabel: 'ګاز شرکت',
    cylinderSizeLabel: 'د سیلنډر اندازه',
    cylinderSizePlaceholder: 'د سیلنډر اندازه وټاکئ',
    quantityLabel: 'مقدار',
    companies: {
      bashundhara: 'بشندره ګاز',
      jamuna: 'جمنا ګاز',
      omera: 'عمره ګاز',
      beximco: 'بکسمکو ګاز',
      fresh: 'تازه ګاز',
      totalgaz: 'توتلګاز',
      others: 'نور',
    },
    cylinderSizeOptions: {
      "12kg": '12 کیلو',
      "33kg": '33 کیلو',
      "45kg": '45 کیلو',
    },
    price: {
      header: 'د قیمت تفصیلات',
      unitPrice: 'د واحد قیمت',
      subtotal: 'فرعي مجموع',
      delivery: 'د رسولو چارج',
      total: 'ټول مجموع',
      note: '* په رسولو کې نغدي شتون لري',
      unitSuffix: 'ټوټې',
    },
    orderNow: 'اوس امر کړئ',
  },
  medicine: {
    title: 'عاجل درمل خدمت',
    medicineNameLabel: 'د درمل نوم',
    medicineNamePlaceholder: 'کوم درمل اړین دی؟',
    urgencyLabel: 'د عاجلیت کچه',
    urgencyOptions: {
      normal: 'عادي',
      urgent: 'عاجل',
      emergency: 'عاجل',
    },
    prescriptionLabel: 'نسخه (که شتون ولري)',
    prescriptionPlaceholder: 'د ډاکتر نسخه یا د درمل تفصیلات',
    uploadNote: 'د نسخې اپلوډ اختیاري دی؛ تاسو کولی شئ یو انځون یا PDF اپلوډ کړئ.',
    uploadButton: 'نسخه اپلوډ کړئ (اختیاري)',
    selectedFilePrefix: 'ټاکل شوی فایل:',
    submit: 'عاجل امر کړئ',
  }
};

export default emergencyAf;
